import axios from "axios";
import { BASE_URL } from "../../config/api_collection";

const LOGGING = `${BASE_URL}/api/ibe/logship/s3`;

export class Logger {
  
  // eslint-disable-next-line no-use-before-define
  private static _instance: Logger;

  private logsMap: Map<string, Array<any>> = new Map();

  private constructor() {
    // Do nothing
  }

  public static get Instance() {
    // eslint-disable-next-line no-return-assign
    return this._instance || (this._instance = new this());
  }

  public log(tag: string, message: any, error: Error | null = null): void {
    const formattedMessage = {
      message,
      exceptionMessage: error?.message,
      exceptionStack: error?.stack
    };

    let logsArray = this.logsMap.get(tag);
    if (logsArray == null) {
      logsArray = new Array<any>();
    }
    logsArray.push(formattedMessage);
    this.logsMap.set(tag, logsArray);
  }

  public end(tag: string, message: string, pnr: String | null = null, error: Error | null = null): void {
    this.log(tag, message, error);
    const logsString = this.logsMap.get(tag);
    if (logsString != null) {
      this.postLogs(`${pnr}_${tag}`, JSON.stringify(logsString));
    }
    this.logsMap.delete(tag);
  }

  // eslint-disable-next-line class-methods-use-this
  private postLogs(tag: string, logs: string) {
    const dateTimeStamp = new Date().toISOString();
    const dateStamp = dateTimeStamp.slice(0, 10);
    const timeStamp = dateTimeStamp.slice(11, 19).replaceAll(":", "");
    axios
      .get(`${LOGGING}?logKey=${tag}-${dateStamp}-${timeStamp}`)
      .then((response) => {
        const headers = { "Content-Type": "text/plain" };
        return axios.put(response.data.data.url, logs, { headers });
      })
      .catch((e) => console.warn("Error in the post logs api", e));
  }
}
